import React, { useState, useEffect } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import EditFlightBookingModal from "./EditFlightBookingModal"; // We'll create this component
import BarcodeGenerator from "./BarcodeGenerator";
import { buildBoardingPassScanText, getPnrCodes } from "./boardingPassBarcode";
import './FlightBooking.css';

const FlightBookingDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const { user, loading } = useAuth();
  const [bookingDetails, setBookingDetails] = useState({});
  const [travellers, setTravellers] = useState([]);
  const [itinerary, setItinerary] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);

  function getTimeFromMins(mins) {
    var h = (mins / 60) | 0,
      m = mins % 60 | 0;
    var durationformat = h + "h " + m + "m";
    return durationformat;
  }

  const GetData = () => {
    setPageLoading(true);
    apiService
      .getAll(config.GETFLIGHTBOOKINGDETAILS + "/" + params.flightBookingId)
      .then((res) => {
        console.log(res);
        setBookingDetails(res);
        setItinerary(res.dcFlightLegs);
        setTravellers(res.travellerInfos);
        setPageLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching company data", err);
        setPageLoading(false);
      });
  };

  const handleEditSuccess = () => {
    setShowEditModal(false);
    GetData(); // Refresh the data after successful update
  };

  useEffect(() => {
    GetData();
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) { navigate("/"); }


  const statusClass = bookingDetails.bookingStatus === "CONFIRMED" ? "fb-status-confirmed"
    : bookingDetails.bookingStatus === "HOLD" ? "fb-status-hold" : "fb-status-pending";

  // Check if any departure date is today or future
  const isFutureDeparture = itinerary.some(it =>
    it.dcDisplayLegs?.some(leg =>
      moment(leg.startSegment?.departureDateTime).isSameOrAfter(moment().startOf('day'))
    )
  );
 

  const totalFareVal = parseFloat(bookingDetails.totalFare || 0);
  const totalPriceVal = parseFloat(bookingDetails.totalPrice || 0);
  
  const baseFareVal = parseFloat(bookingDetails.baseFare || 0);
  const airlineTaxVal = parseFloat(bookingDetails.tax || 0);

  const convinFeeVal = parseFloat(bookingDetails.convenienceFee || 0);
  const pgAmountVal = parseFloat(bookingDetails.paymentGatewayAmount || 0);
  const markupVal = parseFloat(bookingDetails.markup || 0);
  const discountVal = parseFloat(bookingDetails.discount || 0);

  const platformFeeVal = Math.max(0, totalPriceVal - totalFareVal - convinFeeVal- markupVal - pgAmountVal + discountVal);

  const calculatedTotalVal = totalPriceVal;
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content" style={{ background: '#f4f7fb' }}>
          <div className="container-fluid">
            {pageLoading ? (
              <div className="fb-card p-4 text-center">
                <img src="/assets/images/loader.webp" width={48} height={48} alt="" loading="lazy" />
                <p className="text-muted mt-2 mb-0">Loading booking details...</p>
              </div>
            ) : (
              <div className="row g-4 mt-0">
                <div className="col-lg-8">
                  {/* Booking Header */}
                  <div className="fb-card">
                    <div className="fb-card-header" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                      <div className="d-flex align-items-center gap-2">
                        <span className="fb-card-header-icon"><i className="ri-flight-takeoff-line" /></span>
                        <h6>Flight Booking Details</h6>
                        {bookingDetails.bookingStatus && (
                          <span className={`fb-status-badge ${statusClass}`}>
                            <i className="ri-checkbox-circle-line me-1" />{bookingDetails.bookingStatus}
                          </span>
                        )}
                      </div>
                      <div className="d-flex gap-2 flex-wrap">
                       {/* {(bookingDetails.bookingStatus === "SUCCESS" ||
  bookingDetails.bookingStatus === "CONFIRMED") && (
                          <>
                            <Link to={"/flight/voucher/" + params.flightBookingId} className="btn btn-sm btn-primary d-flex align-items-center gap-1">
                              <i className="ri-file-text-line" />Voucher
                            </Link>
                            <Link to={"/flight/invoice/" + params.flightBookingId} className="btn btn-sm btn-secondary d-flex align-items-center gap-1">
                              <i className="ri-receipt-line" />Invoice
                            </Link>
                          </>
                        )} */}
                          {isFutureDeparture && (
                          <button onClick={() => setShowEditModal(true)} className="btn btn-sm btn-warning d-flex align-items-center gap-1">
                            <i className="ri-edit-line" />Edit
                          </button>
                        )}

                        {/* Documents Dropdown Menu */}
                        {(bookingDetails.bookingStatus === "CONFIRMED" && bookingDetails.paymentStatus === "SUCCESS") && (
                          <div className="dropdown">
                            <button 
                              className="btn btn-sm btn-secondary dropdown-toggle d-flex align-items-center gap-1" 
                              type="button" 
                              id="documentsDropdown" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              <i className="ri-file-list-3-line" /> Documents
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="documentsDropdown">
                              <li>
                                <Link className="dropdown-item d-flex align-items-center gap-2" to={"/flight/voucher/" + params.flightBookingId}>
                                  <i className="ri-file-text-line text-primary" /> Voucher
                                </Link>
                              </li>
                              <li>
                                <Link className="dropdown-item d-flex align-items-center gap-2" to={"/flight/invoice/" + params.flightBookingId}>
                                  <i className="ri-file-paper-2-line text-secondary" /> Invoice
                                </Link>
                              </li>
                              <li>
                                <Link className="dropdown-item d-flex align-items-center gap-2" to={"/flight/customer-invoice/" + params.flightBookingId}>
                                  <i className="ri-file-paper-2-line text-info" /> Customer Invoice
                                </Link>
                              </li>
                            </ul>
                          </div>
                        )}
                      
                      </div>
                    </div>
                    <div className="fb-card-body">
                      {/* Booking Info Pills */}
                      <div className="mb-3">
                        {bookingDetails.pnr && <span className="fb-info-pill"><i className="ri-qr-code-line" /><strong>PNR:</strong> {bookingDetails.pnr}</span>}
                        {bookingDetails.bookingNo && <span className="fb-info-pill"><i className="ri-hashtag" /><strong>Booking No:</strong> {bookingDetails.bookingNo}</span>}
                        {bookingDetails.supplierBookingId && <span className="fb-info-pill"><i className="ri-store-2-line" /><strong>Supplier Ref:</strong> {bookingDetails.supplierBookingId}</span>}
                        {bookingDetails.cabinClass && <span className="fb-info-pill"><i className="ri-vip-crown-line" /><strong>Class:</strong> {bookingDetails.cabinClass}</span>}
                      </div>

                      {/* Flight Legs */}
                      {itinerary.length > 0 && itinerary.map((it, itIdx) => (
                        it.dcDisplayLegs?.length > 0 && it.dcDisplayLegs.map((leg, legIdx) => (
                          <div className="fb-leg-card mb-3" key={`${itIdx}-${legIdx}`}>
                            <div className="fb-leg-header">
                              <div className="fb-leg-route">
                                <span className="fb-leg-city">{leg.startSegment.city}</span>
                                <span className="fb-leg-arrow"><i className="ri-arrow-right-line" /></span>
                                <span className="fb-leg-city">{leg.endSegment.city}</span>
                                <span className="fb-leg-date ms-2">{moment(leg.startSegment.departureDateTime).format('DD MMM YY')}</span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                {it.flightLeg?.refundable === "Refundable"
                                  ? <span className="fb-badge-refundable">Refundable</span>
                                  : <span className="fb-badge-nonrefundable">Non-Refundable</span>
                                }
                              </div>
                            </div>
                            <div className="fb-leg-body">
                              {/* Segments */}
                              {it.dcSegments?.map((seg, si) => (
                                <div key={si}>
                                  <div className="fb-timeline mb-2">
                                    <div className="fb-timeline-airline">
                                      <img src={"/assets/images/airlinelogos/" + seg.tFAirlineData?.airlineCode + ".png"} alt="" loading="lazy" />
                                      <div>
                                        <div className="fb-airline-name">{seg.tFAirlineData?.airline}</div>
                                        <div className="fb-airline-code">{seg.tFAirlineData?.equimentType}-{seg.tFAirlineData?.flightNumber}</div>
                                      </div>
                                    </div>
                                    <div className="fb-timeline-point">
                                      <div className="fb-time">{moment(seg.tFDepartureData.departureDateTime).format("HH:mm")}</div>
                                      <div className="fb-airport">{seg.tFDepartureData.airportName}</div>
                                      <div className="fb-date-small">{seg.tFDepartureData.city}{seg.tFDepartureData.terminal ? `, T${seg.tFDepartureData.terminal}` : ''}</div>
                                    </div>
                                    <div className="fb-timeline-connector">
                                      <div className="fb-duration">{getTimeFromMins(seg.tFAirlineData?.duration)}</div>
                                      <div className="fb-connector-line" />
                                    </div>
                                    <div className="fb-timeline-point">
                                      <div className="fb-time">{moment(seg.tFArrivalData.arrivalDateTime).format("HH:mm")}</div>
                                      <div className="fb-airport">{seg.tFArrivalData.airportName}</div>
                                      <div className="fb-date-small">{seg.tFArrivalData.city}{seg.tFArrivalData.terminal ? `, T${seg.tFArrivalData.terminal}` : ''}</div>
                                    </div>
                                  </div>
                                  {seg.tFAirlineData.connectingTime !== 0 && (
                                    <div className="mt-1 mb-2">
                                      <span className="fb-connecting-time"><i className="ri-time-line" />Connecting: {getTimeFromMins(seg.tFAirlineData.connectingTime)}</span>
                                    </div>
                                  )}
                                </div>
                              ))}
                              {bookingDetails.dcPriceDetails?.length > 0 && (
                                <div className="mt-2">
                                  <span className="fb-info-pill"><i className="ri-briefcase-line" /><strong>Adult Baggage:</strong> Check-in {bookingDetails.dcPriceDetails[0].dcAdults.checkinBag}, Cabin {bookingDetails.dcPriceDetails[0].dcAdults.cabinBag}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ))}
                    </div>
                  </div>

                  {/* Traveler Details */}
                  <div className="fb-card">
                    <div className="fb-card-header">
                      <span className="fb-card-header-icon"><i className="ri-group-line" /></span>
                      <h6>Traveler Details</h6>
                    </div>
                    <div className="fb-card-body">
                      <div className="table-responsive">
                        <table className="table table-hover table-bordered" style={{ fontSize: '0.82rem' }}>
                          <thead className="table-light">
                            <tr><th>#</th><th>Name</th><th>PNR</th><th>Baggage</th><th>Meals</th><th>Seat</th></tr>
                          </thead>
                          <tbody>
                            {travellers.map((t, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div>{t.title}.{t.firstName} {t.lastName}</div>
                                  <BarcodeGenerator
                                    value={buildBoardingPassScanText(bookingDetails, t)}
                                    size={80}
                                    style={{ marginTop: 4 }}
                                  />
                                </td>
                                <td>{getPnrCodes(bookingDetails.pnr) || "—"}</td>
                                <td>
  {t.dcBaggageTypes?.[0] ? (
    <div className="d-flex align-items-center gap-1">
      <span className="badge bg-light text-dark border" style={{ fontSize: '0.7rem' }}>
        {t.dcBaggageTypes[0].name}
      </span>
      <span>{t.dcBaggageTypes[0].description}</span>
    </div>
  ) : "—"}
</td>
                               <td>
  {t.dcMealTypes?.[0] ? (
    <div className="d-flex align-items-center gap-1">
      <span className="badge bg-light text-dark border" style={{ fontSize: '0.7rem' }}>
        {t.dcMealTypes[0].name}
      </span>
      <span>{t.dcMealTypes[0].description}</span>
    </div>
  ) : "—"}
</td>
                                <td>{t.dcSeatTypes?.[0]?.description || "—"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Summary Sidebar */}
                
                  <div className="col-lg-4">
                  <div className="fb-fare-card">
                    <div className="fb-fare-header">
                      <h6><i className="ri-receipt-line me-2" />Price Summary</h6>
                    </div>
                    <div className="p-3">
                      <div className="fb-fare-row">
                        <span className="fb-fare-label">Base Fare</span>
                        <span className="fb-fare-value">{Math.round(baseFareVal)} INR</span>
                      </div>

                      <div className="fb-fare-row">
                        <span className="fb-fare-label">Airline Tax</span>
                        <span className="fb-fare-value">{Math.round(airlineTaxVal)} INR</span>
                      </div>

                      {platformFeeVal > 0 && (
                        <div className="fb-fare-row">
                          <span className="fb-fare-label">Platform Fee (18% GST Included)</span>
                          <span className="fb-fare-value">{Math.round(platformFeeVal)} INR</span>
                        </div>
                      )}

                      
                      {convinFeeVal > 0 && (
                        <div className="fb-fare-row">
                          <span className="fb-fare-label">Convenience Fee (18% GST Included)</span>
                          <span className="fb-fare-value">{Math.round(convinFeeVal)} INR</span>
                        </div>
                      )}

                      {/* Separated: Payment Gateway Fee Row (Only if gateway fee > 0) */}
                      {pgAmountVal > 0 && (
                        <div className="fb-fare-row">
                          <span className="fb-fare-label">Payment Gateway Fee</span>
                          <span className="fb-fare-value">{pgAmountVal.toFixed(2)} INR</span>
                        </div>
                      )}

                      {discountVal > 0 && (
                        <div className="fb-fare-row">
                          <span className="fb-fare-label">Discount</span>
                          <span style={{ color: '#16a34a', fontWeight: 600 }}>
                            (-{Math.round(discountVal)} INR)
                          </span>
                        </div>
                      )}
                       {markupVal > 0 && (
                        <div className="fb-fare-row mt-3 pt-3">
                          <span className="fb-fare-label" style={{ fontWeight: 600 }}>Markup</span>
                          <span className="fb-fare-value" style={{ fontWeight: 600, color: "#1e3a8a" }}>
                            {Math.round(markupVal)} INR
                          </span>
                        </div>
                      )}

                      {/* Total B2B Payable Amount */}
                      <div className="fb-fare-total mt-3">
                        <span className="fb-fare-total-label">Total Amount</span>
                        <span className="fb-fare-total-value">{Math.round(calculatedTotalVal)} INR</span>
                      </div>

                      {/* Agent Markup displayed strictly below the Total Amount */}
                     
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showEditModal && (
        <EditFlightBookingModal
          bookingDetails={bookingDetails}
          onClose={() => setShowEditModal(false)}
          onSuccess={handleEditSuccess}
        />
      )}
    </div>
  );
};

export default FlightBookingDetails;
